
import HttpClient from "@/services/HttpClient/HttpClient";
import Vue from "vue";

export default Vue.extend({
  name: "BrowseJobByCategory",
  data: function () {
    return {
      categories: null,
      displayComponent: true,
    };
  },
  props: {
    displayErrorSnackbar: Function,
  },
  mounted() {
    const httpClient = new HttpClient();
    httpClient
      .browseCategoriesForHomepage()
      .then((value) => {
        this.categories = value.data;
      })
      .catch((reason) => {
        console.error(reason);
        this.displayErrorSnackbar("Impossible de joindre le serveur distant");
        this.displayComponent = false;
      });
  },
});
